import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Ticker from '../Ticker';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import { Font, FontWeight } from '../../utils/fonts';
// import Color from '../../utils/colors';


class HeadlineWithTicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: false,
        };

        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { isVisibleByScroll } = nextProps;
        const { clientWidth } = document.documentElement;
        if (clientWidth < 1024) {
            this.setState({ isVisible: isVisibleByScroll });
        }
    }

    handleMouseEnter() {
        const { clientWidth } = document.documentElement;
        if (clientWidth >= 1024) {
            this.setState({ isVisible: true });
        }
    }

    handleMouseLeave() {
        const { clientWidth } = document.documentElement;
        if (clientWidth >= 1024) {
            this.setState({ isVisible: false });
        }
    }

    render() {
        const {
            className, headline = '', words, linkTo, onClick,
        } = this.props;
        const { isVisible } = this.state;

        return (
            <Root
                className={className}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
                onClick={onClick}
            >
                <TickerStyled words={words} isVisible={isVisible} />
                <StyledLink to={linkTo}>
                    <Headline
                        isVisible={isVisible}
                        className="headline"
                    >
                        <LeftGradient />
                        {headline}
                        <RightGradient />
                    </Headline>
                </StyledLink>
            </Root>
        );
    }
}

const Root = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;

    position: relative;
    cursor: pointer;

    ${mediaWidth.m} {
        justify-content: center;
        align-items: center;
    }
`;

const StyledLink = styled.div`
    display: block;
    text-decoration: none;
`;

const Headline = styled.div`
    min-width: 328px;
    position: relative;

    ${Font.HEADLINE};
    ${FontWeight.REGULAR};
    text-transform: uppercase;

    background: #FFFFFF;
    
    ${({ isVisible }) => (isVisible ? `
        font-size: 28px;
        line-height: 26px;
        color: #0032A0;
        ` : `
        font-size: 24px;
        line-height: 26px;
        color: #000000;
    `)}

     transition: all 0.2s;
     backface-visibility: hidden;

    :active {
        color: #002679;
    }

    ${mediaWidth.m} {
        max-width: 100%;

        ${({ isVisible }) => (isVisible ? `
        font-size: 40px;
        line-height: 48px;
        color: #0032A0;
        ` : `
        font-size: 32px;
        line-height: 48px;
    `)}

        :active {
            color: #002679;
            background: #FFFFFF;
        }
    }

    ${mediaWidth.l} {
        :hover {
            color: #0032A0;
        }

        ${({ isVisible }) => (isVisible ? `
            font-size: 56px;
            line-height: 64px;

            background: #FFFFFF;
        ` : `
            font-size: 48px;
            line-height: 56px;
    `)}
    }

    ${mediaWidth.xl} {
        ${({ isVisible }) => (isVisible ? `
        font-size: 64px;
        line-height: 64px;
    ` : `
        font-size: 56px;
        line-height: 64px;
    `)}
    }
`;

const TickerStyled = styled(Ticker)`
    display: flex;
    transform: ${({ isVisible }) => `translateX(${isVisible ? '0px' : '100%'})`};
    opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
    transition: opacity 1s;
    margin-top: 16px;
    /* margin-bottom: ${({ isVisible }) => (isVisible ? '56px' : '0px')}; */

    ${mediaWidth.l} {
        position: absolute;
        top: auto;
        margin-top: 0px;

        transform: ${({ isVisible }) => `translateX(${isVisible ? '0px' : '100%'})`};
    }
`;

const LeftGradient = styled.div`
    display: none;

    ${mediaWidth.l} {
        width: 112px;
        height: 64px;

        position: absolute;
        display: block;

        background: linear-gradient(180deg, #FFFFFF 54.69%, rgba(255, 255, 255, 0) 100%);
        transform: rotate(90deg);

        left: -88px;
        bottom: 0;
    }
`;

const RightGradient = styled.div`
    display: none;

    ${mediaWidth.l} {
        width: 112px;
        height: 64px;

        position: absolute;
        display: block;

        background: linear-gradient(180deg, #FFFFFF 54.69%, rgba(255, 255, 255, 0) 100%);
        transform: matrix(0, 1, 1, 0, 0, 0);

        right: -88px;
        bottom: 0;
    }
`;

export default HeadlineWithTicker;
